import { render, staticRenderFns } from "./OMessageHeader.vue?vue&type=template&id=929d1936&scoped=true&"
import script from "./OMessageHeader.vue?vue&type=script&lang=js&"
export * from "./OMessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./OMessageHeader.vue?vue&type=style&index=0&id=929d1936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929d1936",
  null
  
)

export default component.exports